/**
 * https://nl.wikipedia.org/wiki/Rijksregisternummer
 */

export const VALID_SSN_LENGTH = 11

const mod97 = (input: string): string =>
  String(97 - (Number(input) % 97)).padStart(2, '0')

export const isValidSSN = (ssn: string) => {
  // YYMMDD-nnn-cc   120601-842-04  821221 366 34
  const yymmddnnncc = normalize(ssn)
  if (yymmddnnncc.length !== VALID_SSN_LENGTH) {
    return false
  }

  const yymmddnnn = yymmddnnncc.slice(0, 9)
  const cc = yymmddnnncc.slice(9, 11)

  const checksum19 = mod97(`${yymmddnnn}`)
  const checksum20 = mod97(`2${yymmddnnn}`)

  return checksum19 === cc || checksum20 === cc
}

function normalize(ssn: string): string {
  return ssn.replace(/[^0-9]/g, '')
}
